import { render, staticRenderFns } from "./AccessTokenForm.vue?vue&type=template&id=72a9eaac"
import script from "./AccessTokenForm.vue?vue&type=script&lang=js"
export * from "./AccessTokenForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports